// Labelled-field layout: label above, control (passed as `children`, already wired with the same
// `id`), hint below, error below that. DESIGN-VISUAL.md §5.6 rule 1 (sentence case, no ALL-CAPS
// label), §11 (every input has an associated label; an error names what is wrong). The caller
// wires `id`, `aria-describedby` and `aria-invalid` on its own control — this component only lays
// the three pieces out, so it works with `Input`, `Checkbox` or any future control without a
// fragile `cloneElement`.
import type { ReactNode } from 'react';

export interface FieldProps {
  id: string;
  label: string;
  hint?: string;
  error?: string;
  required?: boolean;
  children: ReactNode;
}

export function Field({ id, label, hint, error, required = false, children }: FieldProps) {
  return (
    <div className="flex flex-col gap-s1">
      <label htmlFor={id} className="text-body font-label text-ink">
        {label}
        {required ? <span aria-hidden="true"> *</span> : null}
      </label>
      {children}
      {hint ? (
        <p id={`${id}-hint`} className="text-fine text-ink-soft">
          {hint}
        </p>
      ) : null}
      {error ? (
        <p id={`${id}-error`} role="alert" className="text-fine text-attention">
          {error}
        </p>
      ) : null}
    </div>
  );
}
